module.exports = __webpack_public_path__ + "static/media/video_thumbnail@2x.663f9eee.png";